module.exports = __webpack_public_path__ + "img/inHollGreen.3b8a3bd8.svg";